import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import SBComponentVue from '@/components/SBComponentVue';
import SBRadioGroup from './SBRadioGroup';


@Component({
})
export default class SBRadio extends Mixins(SBComponentVue) {

    @Prop({
        type: Boolean,
        default: false,
    })
    public disable!: boolean;

    @Prop({
        type: [String, Boolean],
        default: "",
    })
    public value!: string | boolean;

    public boxClick() {
        if (this.disable) return;
        let group: SBRadioGroup = <any>this.$parent;
        group.setValue(this.value);
    }

    public getGroupValue() {
        if (this.disable) return;
        let group: SBRadioGroup = <any>this.$parent;
        return group.getValue();
    }

}
